import formInputsTypes from '../../simulatorConstant';
import {
	AxeManuelRM,
	AxeMotoriseRM,
	bobineRM,
	BoiteRM,
	Butee,
	EnroulementRM,
	marqueMoteur,
	MesureHauteur,
	MesureLargeur,
	platBombeRM,
	PoseRM,
	sortieCableRM,
} from '../data';

import ACM190 from 'assets/img/ACM-190.png';
import RideauButee from 'assets/img/rideau-butee.png';
import RideauSansButee from 'assets/img/rideau-sans-butee.png';

import ACM120 from 'assets/img/ACM-120.png';
import ACM140 from 'assets/img/ACM-140.png';
import Gaposa120 from 'assets/img/Gaposa-120.png';
import Gaposa140 from 'assets/img/Gaposa-140.png';
import Gaposa190 from 'assets/img/Gaposa-190.png';
export const CATEG_ID_MOTEUR_RIDEAU = 36;



const NbAgrafesRMData = {
	id: 'NbAgrafesRM',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'NbAgrafesRM',
	className: 'col-6',
	label: "Nombre d'agrafes",
	nextStepData: false,
	nextStep: false,
};

const EnroulementData = {
	id: 'RMENROULEMENT',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'Enroulement',
	className: 'col-6',
	label: 'Enroulement',
	nextStepData: NbAgrafesRMData,
	nextStep: false,
	options: EnroulementRM,
};

const MesureHauteurRMData = {
	id: 'RMH',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'MesureHauteur',
	className: 'col-6',
	label: 'Mesure selon hauteur',
	nextStepData: EnroulementData,
	nextStep: false,
	options: MesureHauteur,
};

const hauteurRM = {
	id: 'HRM',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'hauteurRM',
	className: 'col-6',
	label: "Hauteur de l'axe (mm)",
	nextStepData: MesureHauteurRMData,
	nextStep: false,
	validation: (value) => {
		return value > 0;
	},
};

const MesureLargeurRMData = {
	id: 'RM-TML',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'MesureLargeur',
	className: 'col-6',
	label: 'Mesure selon largeur',
	nextStepData: hauteurRM,
	nextStep: false,
	options: MesureLargeur,
};

const largeurRM = {
	id: 'LRM',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'largeurRM',
	className: 'col-6',
	label: "Largeur de l'axe (mm)",
	nextStepData: MesureLargeurRMData,
	nextStep: false,
	validation: (value) => {
		return value > 0;
	},
};

const PoseRMData = {
	id: 'PoseRM',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Pose',
	name: 'PoseRM',
	className: 'col-6',
	nextStepData: largeurRM,
	nextStep: false,
	options: PoseRM,
};

const sortieCable = {
	id: 'sortieCable',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Sortie du câble',
	name: 'sortieCable',
	className: 'col-6',
	nextStepData: PoseRMData,
	nextStep: false,
	options: sortieCableRM,
};

const bobine = {
	id: 'bobines',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Bobines',
	name: 'bobines',
	className: 'col-6',
	nextStepData: PoseRMData,
	nextStep: false,
	options: bobineRM,
};

const platBombe = {
	id: 'platBombe',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Plat bombé',
	name: 'platBombe',
	className: 'col-6',
	nextStepData: bobine,
	nextStep: false,
	options: platBombeRM,
};

const AxeManuelData = {
	id: 'AxeMRMData',
	type: formInputsTypes?.SELECT_INPUT,
	label: "Type d'axe",
	name: 'AxeMRMData',
	className: 'col-6',
	nextStepData: platBombe,
	nextStep: false,
	options: AxeManuelRM,
};

const BoiteRMData = {
	id: 'BoiteRMData',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Accessoires',
	name: 'BoiteRMData',
	className: 'col-12',
	nextStepData: AxeManuelData,
	options: BoiteRM,
};
const puissance = {
	id: 'RM-PUISSANCE',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Puissance moteur',
	name: 'puissance',
	className: 'col-12',
	nextStepData: BoiteRMData,
	nextStep: false,

	fetchData: (currentFormValue, fnSuccess) => {
		const typeMotorisation =
			currentFormValue?.values?.typeMotorisation?.value;
		const marque =
			currentFormValue?.values?.marque?.value || '';

		let puissances = [];

		switch (typeMotorisation) {
			case 'latéral':
				puissances = [220, 380, 400, 500, 750];
				break;

			case 'tubulaire':
				puissances = [250, 300, 400, 550, 650];
				break;

			case 'central triphasé':
				puissances = [250, 400, 550, 650, 1000];
				break;

			case 'central monophasé':
				puissances = [120, 140, 180, 190, 220];
				break;

			default:
				puissances = [];
		}

		const options = puissances.map((p) => ({
			id: String(p),
			label: `${p} Nm`,
			value: String(p),
			nextStep: false,
			description: `- Puissance moteur ${p} Nm ${marque}.` 

		}));

		fnSuccess(options);
	},
};
const marque = {
	id: 'RM-LAT-MARQUE',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Marque',
	name: 'marque',
	className: 'col-12',
	nextStepData: puissance,
	nextStep: false,
	options: marqueMoteur
};

const AxeMotoriseRMData = {
	id: 'AxeMotoriseRMData',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Motorisation',
	name: 'typeMotorisation',
	className: 'col-6',
	nextStepData: marque,
	nextStep: false,
	options: AxeMotoriseRM,
};

export default AxeMotoriseRMData;
